import React, { useState, useEffect, useContext } from 'react';
import { 
  Col, 
  Container, 
  Row, 
  Form,
 } from 'react-bootstrap';
import { Button, ButtonGroup } from '@/shared/components/Button';
import Pagination from 'react-bootstrap/Pagination';
import { FaFilter, FaExclamationCircle } from 'react-icons/fa';
import toast from 'react-hot-toast';
import RestaurantCard from './RestaurantCard';
import { RestaurantContext } from '../../../../context/RestaurantContext';
import { ThemeContext } from '../../../../context/ThemeContext';
import { SideBarRefreshContext } from '../../../../context/SideBarRefreshContext';

import ProgressBar from '../../Loader';
import { AuthContext } from '../../../../context/AuthContext';


const Search = () => {
  const { refresh } = useContext(RestaurantContext);
  const { currentTheme } = useContext(ThemeContext);
  const [searchQuery, setSearchQuery] = useState(''); 
  const [restaurantdata, setRestaurantData] = useState([]);
  const [filteredRestaurantData, setFilteredRestaurantData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const { apiGlobal, countryid } = useContext(AuthContext);
  const { sideBarRefresh } = useContext(SideBarRefreshContext);

   // Pagination state
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 5;
  
    // Handle page change
    const handlePageChange = (pageNumber) => {
      setCurrentPage(pageNumber);
    };
  
    // Pagination Logic - Slice data for the current page
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  
    // Use filteragent for pagination, not agent
    const currentItems = filteredRestaurantData.slice(indexOfFirstItem, indexOfLastItem);
  
    // Total pages should be based on filteragent length, not agent
    const totalPages = Math.ceil(filteredRestaurantData.length / itemsPerPage);

  const fetchMealsData = async () => {
    setIsLoading(true);
    const formData = new FormData();
    formData.append('country_id', countryid);
    try {
      const response = await fetch(`${apiGlobal}/restaurant_data.php`, {
        method: 'POST',
        body: formData,
      });
      const RestaurantResponse = await response.json();
      if (RestaurantResponse && Array.isArray(RestaurantResponse.data)) {
       //  console.log('Loaded successfully');
        setRestaurantData(RestaurantResponse.data);
        setFilteredRestaurantData(RestaurantResponse.data); 
        // console.log(RestaurantResponse.data);
      } else {
        // console.log('No data found');
        setRestaurantData([]);
        setFilteredRestaurantData([]);
      }
    } catch (error) {
      console.error('Error loading meals', error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchMealsData();
  }, [refresh, sideBarRefresh?.adminRestaurantRefresh]); 

  const handleSearch = (e) => {
    const query = e.target.value;
    setSearchQuery(query);

    if (query) {
      const filteredData = restaurantdata.filter(meal => meal?.name.toLowerCase().includes(query.toLowerCase()));
      setFilteredRestaurantData(filteredData); 
    } else {
        setFilteredRestaurantData(restaurantdata); 
    }
  };

  // // Refresh handler
  // const refreshHandler = () => {
  //   fetchMealsData();
  // };

  
     // use Effect to add keyframes for the pulse animation
     useEffect(() => {
      // Add keyframes via JavaScript when component mounts
      const style = document.createElement('style');
      style.innerHTML = `
        @keyframes pulse {
          0% { transform: scale(1); opacity: 1; }
          50% { transform: scale(1.2); opacity: 0.8; }
          100% { transform: scale(1); opacity: 1; }
        }
      `;
      document.head.appendChild(style);
    }, []);

  if (isLoading) {
      return (
        <div
          style={{
            display: 'flex',
            // justifyContent: 'center', // Center horizontally
            // alignItems: 'center', // Center vertically
            height: '100vh', // Full viewport height
          }}
        >
          <ProgressBar />
        </div>
      );
    }

    const refreshHandler = () => {
      fetchMealsData();
      setSearchQuery('');
      toast.success('Data refreshed successfully');
    };

 
  return (
    <Container>
      <Row>
        <Col md={12} />
      </Row>

      <Row>
        <div className="col-md-4 mb-4 d-flex align-items-center">
          <Form.Control
            type="text"
            placeholder="Search by Restaurant Name..."
            value={searchQuery}
            onChange={handleSearch}
            className="flex-grow-1 rounded"
            style={{
              backgroundColor: currentTheme === 'Dark' ? '#232329' : 'white',
              color: currentTheme === 'Dark' ? 'white' : 'black',
            }}
          />
          <ButtonGroup icons dir="ltr" className="mt-2">
            <Button
              variant="outline-secondary"
              className="ms-3"
              title="Refresh"
              size="sm"
              onClick={refreshHandler}
            >
              <span className="lnr lnr-sync" />
            </Button>
          </ButtonGroup>

          {/* <ButtonGroup icons dir="ltr" className="mt-2 mx-2">
            <Button 
              variant="outline-info"
              title="Filter" 
            >
              <FaFilter />
            </Button>
          </ButtonGroup> */}
        </div>
      </Row>

      <Row>
        <div>
          {filteredRestaurantData.length === 0 ? (
                  // If search results are empty
            <div style={{
                    textAlign: 'center',
        padding: '50px',
        backgroundColor: '#f8d7da',
        borderRadius: '8px',
        marginTop: '20px',
                    color: '#721c24',
        fontSize: '16px',
                  }}
            >
              <div
                style={{
    fontSize: '48px',
    marginBottom: '20px',
    color: '#e63946',
    animation: 'pulse 1.5s infinite ease-in-out',
    display: 'inline-block',
    }}
              >
                <FaExclamationCircle style={{ fontSize: '48px', marginBottom: '20px' }} />
              </div>
              <p>{searchQuery ? 'No results found for your search' : 'No Restaurant available'}</p>
            </div>
                ) : (
            currentItems.map(restaurant => (
              <div key={restaurant.id}>
                <RestaurantCard
                  id={restaurant.id}
                  name={restaurant.name}
                  format={restaurant.meal_format}
                  mealOffered={restaurant.meal_offered}
                  cuisines={restaurant.cuisines}
                  capacity={restaurant.capping_capacity}
                  location={restaurant.location}
                  clipcapacity={restaurant.setting_capacity}
                  image={restaurant.photo}
                  count={restaurant.location_count}
                  activestatus={restaurant?.active_status}
                  theme={currentTheme}
                />
              </div>
            ))
          )}
        </div>
      </Row>
      {/* Pagination Controls */}
      <div
        style={{
          // position: 'fixed', 
          bottom: '20px', 
          right: '20px', 
          zIndex: 999, 
          display: 'flex', 
          justifyContent: 'flex-end', 
          alignItems: 'center',
        }}
      >
        {filteredRestaurantData.length !== 0 && (
          <Pagination>
            <Pagination.Prev
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
            />
            {Array.from({ length: totalPages }, (_, index) => (
              <Pagination.Item
                key={index + 1}
                active={index + 1 === currentPage}
                onClick={() => handlePageChange(index + 1)}
              >
                {index + 1}
              </Pagination.Item>
          ))}
            <Pagination.Next
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
            />
          </Pagination>
        )}
        
      </div>
    </Container>
  );
};

export default Search;
